const HAMBURGER = document.getElementById('js_hamburgerBtn');
import { linkWithinPageControl } from "./bundle/_scrollToAnchor";
import { drawerDisplayControl } from "./bundle/_drawerControl";

// ハンバーガーボタンのクリックイベントを登録する
if (HAMBURGER) {
  HAMBURGER.addEventListener('click', drawerDisplayControl, false);
}

// ページ内リンクをスムーススクロールさせるためクリックイベントを登録する
document.addEventListener('DOMContentLoaded', linkWithinPageControl, false);

{
  const tabs = document.querySelectorAll('.js_newArrivalsTab');
  tabs.forEach(tab => {
    tab.addEventListener('click', function() {
      tabs.forEach(tab => {
        tab.classList.remove('_active');
      });
      tab.classList.add('_active');

      const sliders = document.querySelectorAll('.js_newArrivalsSlider');
      sliders.forEach(slider => {
        slider.classList.remove('_active');
      });
      const targetId = tab.dataset.targetId;
      const target = document.getElementById(targetId)
      target.classList.add('_active');

      const publishedAt = target.dataset.publishedAt;
      const productsCount = target.dataset.productsCount;

      const publishedAtElement = document.querySelectorAll('.js_newArrivalsPublishedAt')
      const productsCountElement = document.querySelectorAll('.js_newArrivalsProductsCount')

      publishedAtElement.forEach(e => {
        e.innerHTML = publishedAt;
      });

      productsCountElement.forEach(e => {
        e.innerHTML = productsCount;
      });
    });
  });
}

/**
 * Adobe Fontsを使用しているときに起こる、ロード時のフォントのちらつきを抑制する
 */
// (function(d) {
//   var config = {
//     kitId: 'rlk1wzr',
//     scriptTimeout: 3000,
//     async: true
//   },
//   h=d.documentElement,t=setTimeout(function(){h.className=h.className.replace(/\bwf-loading\b/g,"")+" wf-inactive";},config.scriptTimeout),tk=d.createElement("script"),f=false,s=d.getElementsByTagName("script")[0],a;h.className+=" wf-loading";tk.src='https://use.typekit.net/'+config.kitId+'.js';tk.async=true;tk.onload=tk.onreadystatechange=function(){a=this.readyState;if(f||a&&a!="complete"&&a!="loaded")return;f=true;clearTimeout(t);try{Typekit.load(config)}catch(e){}};s.parentNode.insertBefore(tk,s)
// })(document);

{
  const priceRangeInput = document.querySelectorAll('.price-range__input');
  priceRangeInput.forEach(e => {
    e.addEventListener('change', function() {
      const value = e.value;
      const target = document.getElementById(e.dataset.target);
      const step = e.step;
      if (e.dataset.target == 'price-min') {
        const maxValue = document.getElementById('Filter-価格-LTE').value ? document.getElementById('Filter-価格-LTE').value : e.max;
        console.log({maxValue});
        if (Number(maxValue) <= Number(value)) {
          console.log('maxValue <= value');
          e.value = Number(maxValue) - Number(step);
          document.getElementById('Filter-価格-GTE').value = Number(maxValue) - Number(step);
        } else {
          document.getElementById('Filter-価格-GTE').value = value;
        }
      } else {
        const minValue = document.getElementById('Filter-価格-GTE').value ? document.getElementById('Filter-価格-GTE').value : e.min;
        console.log({minValue});
        if (Number(minValue) >= Number(value)) {
          console.log('minValue >= value');
          e.value = Number(minValue) + Number(step);
          document.getElementById('Filter-価格-LTE').value = Number(minValue) + Number(step);
        } else {
          document.getElementById('Filter-価格-LTE').value = value;
        }
      }
      target.textContent = e.value;
    });
  });
}